import React, { useState, useEffect, useCallback } from "react";
import Grid from "@material-ui/core/Grid";
import { Button } from "@material-ui/core";
import AddIcon from "@material-ui/icons/AddCircle";
import guid from "../../helpers/guid.helper";
import GuestListItem from "./GuestListItem";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import { connect } from "react-redux";

const useStyles = makeStyles((theme) => ({
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: "2%",
    backgroundColor: "var(--white)",
    marginBottom: "2%",
    [theme.breakpoints.down("sm")]: {
      padding: "2%",
    },
  },
  main: {
    paddingTop: "10%",
    minHeight: "100vh",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "32%",
    },
  },
}));

function PassengerList(props) {
  const { roomsArr } = props
  const classes = useStyles();
  const handleChange = (value, key, roomNumber, adultCount) => {
    let arr = roomsArr
    arr[roomNumber]['GuestInfo'][adultCount]['Name'][key] = value
    props.handleChange(arr) 
  }

  return (
    <Grid container>
      <Grid container style={{ marginBottom: "10px" }}>
        <Grid item xs="6">
          <Typography
            variant="h6"
            style={{
              color: "var(--darker)",
              textAlign: "left",
              textTransform: "capitalize",
            }}
          >
            {" "}
            {'Guest'}{" "}
          </Typography>
        </Grid>

      </Grid>
      <Paper className={classes.control} elevation={0} style={{width:'100%'}}>
          {roomsArr.map((passenger, i) => {
            return passenger['GuestInfo'] && Array.isArray(passenger['GuestInfo']) && passenger['GuestInfo'].map((p, j) => {
              return <GuestListItem
                key={i+''+j}
                index={j}
                data={p}
                roomNumber={i}
                onChange={handleChange}
              />
            })
          })}
          {/* {roomsArr.map((passenger, i) => {
            return roomsArr.map((passenger, i) => (
              
            )
            })} */}
      </Paper>
    </Grid>
  );
}


export default PassengerList;

PassengerList.defaultProps = {
  adults: 1,
  childs: 0,
  infants: 0,
};
